/**
 * Combine all admin scripts
 * (which only run on the wpm pages)
 */

// require("./environment-check")
require("./helpers")
require("./script-blocker-warning")
require("./tabs")
require("./save")
require("./ssp")

// #if process.env.TIER === 'premium'
// // require("./helpers_premium")
// #endif

// console.log('Pixel Manager for WooCommerce admin script')
